export default __webpack_public_path__ + "static/media/Acmw img.4b2b3151.png";